import { trpc } from '@/shared/api';

export const useHomePortfoliosQuery = () =>
  trpc.portfolio.home.useQuery(undefined, { retry: false });
